import { jsx as _jsx } from "react/jsx-runtime";
import crossSVG from "Images/quiz/x.svg";
import React, { memo } from "react";
import styles from "./styles.module.scss";
const BottomCross = (props) => (_jsx("div", { className: styles.crossContainer, children: _jsx("button", { type: "button", onClick: props.setOpen, children: _jsx("img", { src: crossSVG, alt: "cross" }) }) }));
export default memo(BottomCross);
